import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Notifications"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold fs-6" }, " Decide the frequency of receiving communications from us with curated investment opportunities. ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "notifications" }, null, -1)
const _hoisted_4 = { class: "fv-row mb-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "How often should we update you?", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: "daily"
}, "Daily", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "twiceAWeek" }, "Twice a Week", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: "weekly" }, "Weekly", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: "everyOtherWeek" }, "Every Other Week", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: "monthly" }, "Monthly", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_Field, {
        modelValue: _ctx.notification,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.notification) = $event)),
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fieldChanged($event))),
        name: "notification",
        class: "form-select form-select-lg form-select-solid",
        "data-control": "select2",
        "data-placeholder": "Select...",
        "data-allow-clear": "true",
        "data-hide-search": "true",
        as: "select"
      }, {
        default: _withCtx(() => [
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _hoisted_10
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_ErrorMessage, {
        name: "notification",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ])
  ]))
}